// src/services/Master/MasterPaket.js
// (Versi ini disesuaikan dari template MasterJenisSeleksi Anda)

import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE; // Ensure this env variable is set

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`
});


export const fetchPaket = async (options = {}) => {
  try {
    const params = new URLSearchParams();

    // Logika untuk paginasi atau disable_pagination
    if (options.disable_pagination) {
      params.append('disable_pagination', 'true');
    } else {
      params.append('page', options.page || 1);
      params.append('per_page', options.per_page || 10);
    }

    // Tambahkan filter lainnya jika ada di dalam objek 'filters'
    if (options.filters) {
      if (options.filters.nama_paket) {
        params.append('nama_paket', options.filters.nama_paket);
      }
      // Tambahkan filter id_jenis_seleksi
      if (options.filters.id_jenis_seleksi) {
        params.append('id_jenis_seleksi', options.filters.id_jenis_seleksi);
      }
      // Tambahkan filter id_tipe_konten
      if (options.filters.id_tipe_konten) {
        params.append('id_tipe_konten', options.filters.id_tipe_konten);
      }
      // Tambahkan filter is_aktif
      // Perhatikan bahwa is_aktif bisa berupa boolean atau string "0"/"1"
      if (options.filters.is_aktif !== undefined && options.filters.is_aktif !== null && options.filters.is_aktif !== '') {
        params.append('is_aktif', options.filters.is_aktif);
      }
    }

    const response = await axios.get(`${BASE_URL_BE}/master-paket?${params.toString()}`, { // Mengubah endpoint
      headers: getAuthHeaders()
    });

    const meta = response.data.meta || {};
    const calculated_last_page = options.disable_pagination ? 1 : (Math.ceil(meta.total / meta.per_page) || 1);
    const currentPage = options.disable_pagination ? 1 : (meta.page || (options.page || 1));
    const currentPerPage = options.disable_pagination ? (meta.total || response.data.data.length || (options.per_page || 10)) : (meta.per_page || (options.per_page || 10));

    return {
      success: response.data.success,
      data: response.data.data || [],
      message: response.data.message || "",
      code: response.data.code || 200,
      meta: {
        page: currentPage,
        per_page: currentPerPage,
        total: meta.total || (options.disable_pagination ? response.data.data.length : 0),
        last_page: calculated_last_page
      }
    };
  } catch (error) {
    console.error("Error fetching Paket:", error); // Diperbarui log pesan error
    throw {
      success: false, 
      message: error.response?.data?.message || "Failed to fetch paket.", // Diperbarui pesan error
      errors: error.response?.data?.errors,
      code: error.response?.status
    };
  }
};


// --- Create a new Paket ---
export const createPaket = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}/master-paket`, formData, { // Mengubah endpoint
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data' 
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Paket:", error); // Diperbarui log pesan error
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to create paket.", // Diperbarui pesan error
      errors: error.response?.data?.errors,
      code: error.response?.status
    };
  }
};

// --- Update an existing Paket ---
export const updatePaket = async (id_paket, formData) => { // id_paket sudah benar
  try {
    // Menggunakan axios.put sesuai dengan contoh Anda
    const response = await axios.put(`${BASE_URL_BE}/master-paket/${id_paket}`, formData, { // Mengubah endpoint
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data' 
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Paket:", error); // Diperbarui log pesan error
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to update paket.", // Diperbarui pesan error
      errors: error.response?.data?.errors,
      code: error.response?.status
    };
  }
};

// --- Delete a Paket ---
export const deletePaket = async (id_paket) => { // Mengubah nama fungsi
  try {
    const response = await axios.delete(`${BASE_URL_BE}/master-paket/${id_paket}`, { // Mengubah endpoint
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting Paket:", error); // Diperbarui log pesan error
    throw {
      success: false,
      message: error.response?.data?.message || "Failed to delete paket.", // Diperbarui pesan error
      errors: error.response?.data?.errors,
      code: error.response?.status
    };
  }
};


export const fetchPaketDetail = async (id_paket, id_tipe_konten, id_jenis_seleksi) => {
  try {
    const params = {};
    if (id_paket) params.id_paket = parseInt(id_paket, 10);
    // Tambahkan kedua parameter ini ke dalam objek params
    if (id_tipe_konten) params.id_tipe_konten = parseInt(id_tipe_konten, 10);
    if (id_jenis_seleksi) params.id_jenis_seleksi = parseInt(id_jenis_seleksi, 10);

    if (!id_paket || !id_tipe_konten || !id_jenis_seleksi) {
    throw new Error("Semua parameter harus diisi");
  }

    
    console.log("Mengirim permintaan dengan params:", params); // Ini untuk debugging

    const response = await axios.get(`${BASE_URL_BE}/paket-tryout/detail`, {
      headers: getAuthHeaders(),
      params
    });

    if (!response.data.success) {
      throw new Error(response.data.message || "Gagal mendapatkan detail paket.");
    }

    return response.data;
  } catch (error) {
    console.error("Error detail Paket:", error);
    const errorMessage = error.response?.data?.message || error.message || "Terjadi kesalahan pada server.";
    throw new Error(errorMessage);
  }
};